import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useActions } from '../../../hooks/useActions';

export const useInitSessionClient = (
  displayValue,
  setDisplayValue,
  reassignModalIsOpen = null,
) => {
  const { selectedSession } = useSelector((state) => state.sessions);
  const { clients, isLoading: clientsIsLoading } = useSelector(
    (state) => state.clients,
  );

  const { getAllClients } = useActions();

  const therapistOrgId = selectedSession?.therapist?.organizationId;

  useEffect(() => {
    if (clients?.length <= 0 && therapistOrgId)
      getAllClients(`filter[where][organizationId]=${therapistOrgId}`);
  }, [therapistOrgId]);

  useEffect(() => {
    if (selectedSession && clients?.length > 0 && !displayValue) {
      const sessionClient = clients?.find(
        (client) => client?.id === selectedSession?.clientId,
      );
      setDisplayValue({ text: sessionClient?.name, value: sessionClient?.id });
    }
    if (!reassignModalIsOpen) setDisplayValue(null);
  }, [clients, selectedSession, reassignModalIsOpen]);
};
